(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-product-criteria"] && !Shopify.designMode) return;
  try {
    class BlockProductCriteria extends HTMLElement {
    description;
    informations;
    blockId;

    constructor() {
      super();
    }

    connectedCallback() {
      this.blockId = this.getAttribute('id');
      ProductPageStore.subscribe((event) => {
        this.updateComponent(event.detail.currentProduct);
      });
    }

    updateComponent(product) {
      const shortDesc = product.short_desc;
      const additionalInformationItems = product.additional_information;
      const shortDescElement = this.querySelector(`#${this.blockId} .shortDesc`);
      const additionalInformationItemsElement = this.querySelector(`#${this.blockId} .additionalInformationItems`);

      if (!additionalInformationItems || additionalInformationItems.length === 0) {
        this.classList.add('hidden');
      }

      const additionalInformationItemElementsHtml = additionalInformationItems
        .map((item) => {
          return this.getAdditionalInformationItemElement(item.svg_icon, item.description);
        })
        .join('');

      additionalInformationItemsElement.innerHTML = additionalInformationItemElementsHtml;
      shortDescElement.innerHTML = shortDesc;
    }

    getAdditionalInformationItemElement(svgIcon, description) {
      return `<p class="flex gap-2 text-[14px] text-[var(--color-neutral-800)]">
          ${svgIcon}
          ${description ? `<span class="flex-1">${description}</span>` : ''}
        </p>`;
    }
  }

  customElements.define('block-product-criteria', BlockProductCriteria);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["block-product-selector"] && !Shopify.designMode) return;
  try {
    class BlockProductSelector extends HTMLElement {
    constructor() {
      super();
      this.props = { product: {}, description: '' };
      this.state = { currentVariant: {} };
    }

    connectedCallback() {
      this.initProps();
      this.initState();
      this.render(this.getRenderData());
      this.initEventListeners();

      ProductPageStore.subscribe((event) => {
        const currentVariant = this.getMatchedVariantSize();
        this.updateState({
          currentVariant: currentVariant ? currentVariant : this.props.product.variants[0],
        });
      });

      window.eventBus.publish('block-product-selector:rendered', {
        component: this,
        price: this.state.currentVariant.price,
        handle: this.props.product.handle,
      });
    }

    initProps() {
      this.props.product = JSON.parse(this.getAttribute(':product'));
      this.props.itemsInBundle = JSON.parse(this.getAttribute(':items_in_bundle'));
      this.props.product_additional_information = JSON.parse(this.getAttribute(':product_additional_information'));
      this.props.description = this.getAttribute(':description');
      this.props.freebies = JSON.parse(this.getAttribute(':freebies')) ?? [];
      this.props.urgencyCheckoutHtml = JSON.parse(this.getAttribute(':urgencycheckouthtml'));
    }

    initState() {
      const currentVariant = this.getMatchedVariantSize();
      this.updateState({
        currentVariant: currentVariant ? currentVariant : this.props.product.variants[0],
      });
    }

    initEventListeners() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    updateState(updates) {
      this.state = { ...this.state, ...updates };
      this.render(this.getRenderData());
    }

    getMatchedVariantSize() {
      const currentVariant = ProductPageStore.getState().currentVariant;
      if (!currentVariant) return null;

      const size = currentVariant.title.split('(')[0].trim();
      const regex = new RegExp(String.raw`^${size}$`, 'i');
      return this.props.product.variants.find((variant) => regex.test(variant.title.split('(')[0].trim()));
    }

    handleClick() {
      ProductPageStore.setState({
        currentProduct: {
          ...this.props.product,
          ...this.props.product_additional_information,
          items_in_bundle: this.props.itemsInBundle,
        },
        currentVariant: this.state.currentVariant,
        urgencyCheckoutHtml: this.props.urgencyCheckoutHtml,
        freebies: this.props.freebies,
      });
    }

    getRenderData() {
      const result = {};
      result.title = this.props.product.title;
      result.price = this.state.currentVariant.price / 100;
      result.compareAtPrice = this.state.currentVariant.compare_at_price / 100;
      result.isDiscounted = this.state.currentVariant.compare_at_price > this.state.currentVariant.price;
      result.discountPercentage = Math.round(
        ((this.state.currentVariant.compare_at_price - this.state.currentVariant.price) * 100) /
          this.state.currentVariant.compare_at_price
      );
      result.description = this.props.description;
      result.isSelected = ProductPageStore.getState().currentProduct?.id === this.props.product.id;
      return result;
    }

    render(data) {
      this.innerHTML = `
      <div class="p-5 rounded-lg ${
        data.isSelected
          ? 'border-[var(--color-primary-500)] border-2 bg-primary-200'
          : 'border-[var(--color-neutral-400)] border hover:bg-[var(--color-neutral-100)] hover:border-[var(--color-neutral-50)] transition-colors'
      }">
        <p class="font-semibold text-[16px] mb-2">${data.title}</p>
        <p class="text-[16px] text-[var(--color-neutral-500)]">${data.description}</p>
      </div>
    `;
    }
  }

  customElements.define('block-product-selector', BlockProductSelector);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joint-product-banners-items-bundle"] && !Shopify.designMode) return;
  try {
    class SectionJointProductBanner extends HTMLElement {
    description;
    informations;

    constructor() {
      super();
    }

    connectedCallback() {
      this.reInitTabs();
      ProductPageStore.subscribe((event) => {
        const currentProduct = event.detail.currentProduct;
        const sectionId = this.getAttribute('id');
        this.renderTab(sectionId, currentProduct.items_in_bundle);
        this.reviewsReplacement(currentProduct.id, currentProduct.title);
      });
    }

    renderTab(sectionId, items) {
      const jointBannerSection = document.querySelector(`.${sectionId}`);
      const tabWrapper = jointBannerSection.querySelector(`.${sectionId}-tab-wrapper`);
      tabWrapper.innerHTML = items
        .map((item, itemIndex) => {
          return this.renderTabButton(item.title, itemIndex);
        })
        .join('');
      this.reInitTabs(items[0].title);
    }

    reInitTabs(activeTabName) {
      const section = document.querySelector('#joint-product-banners');
      if (section) {
        const tabs = initTabs(section, false);
        tabs.init();
        tabs.selectTab(activeTabName);
      }
    }

    renderTabButton(title, buttonIndex) {
      return `<button
            class="tab_link text-sm md:text-xl md:font-semibold pb-1 border-solid border-[var(--color-neutral-900)] ${
              buttonIndex === 0 ? 'border-b-2' : ''
            }"
            data-tab="${title}"
          >
            ${title}
          </button>`;
    }

    reviewsReplacement(bundleProductId, bundleProductTitle) {
      const existReviewWidget = document.querySelector('#judgeme_product_reviews');
      const targetReviewWidget = document.querySelector('#judgeme_product_reviews_' + bundleProductId);

      if (existReviewWidget) {
        existReviewWidget.setAttribute('data-product-title', bundleProductTitle);
        existReviewWidget.setAttribute('data-id', bundleProductId);
        existReviewWidget.innerHTML = targetReviewWidget.innerHTML;
        const el = document.querySelectorAll('#judgeme_product_reviews img');
        const observer = lozad(el);
        observer.observe();
      }
    }
  }
  customElements.define('section-joint-product-banner', SectionJointProductBanner);

  class BlockJointProductBanner extends HTMLElement {
    constructor() {
      super();

      this.props = { product: {} };
      this.sectionIds = ['section-alternate-banners', 'mattress-layers', 'background-image-banner'];
    }

    async connectedCallback() {
      this.initProps();
      this.render(await this.getRenderData());
    }

    initProps() {
      this.props.product = JSON.parse(this.getAttribute(':product'));
    }

    getRenderData() {
      return this.fetchProduct();
    }

    async fetchProduct() {
      const html = await fetchProductPage(this.props.product.handle);
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      let templates = [];

      this.sectionIds.forEach((sectionId) => {
        const section = doc.querySelector(`.shopify-section[id$="${sectionId}"]`);
        if (section) {
          const sectionContent = section.querySelector('.section-content');
          templates.push(sectionContent.outerHTML);
        }
      });

      return templates.join('');
    }

    render(template) {
      this.insertAdjacentHTML('afterbegin', template);
      if (window.lozad) window.lozad('.lazyload').observe();
    }
  }

  customElements.define('block-joint-product-banner', BlockJointProductBanner);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joint-product-banners-multiple-bundles"] && !Shopify.designMode) return;
  try {
    class BlockJointProductBanner extends HTMLElement {
      constructor() {
        super();

        this.props = { product: {}, mainProductId: 0 };
        this.sectionIds = ['section-alternate-banners', 'mattress-layers', 'background-image-banner'];
      }

      async connectedCallback() {
        this.initProps();
        this.render(await this.getRenderData());
      }

      initProps() {
        this.props.product = JSON.parse(this.getAttribute(':product'));
        this.props.mainProductId = Number(this.getAttribute(':mainProductId'));
      }

      getRenderData() {
        return this.props.mainProductId === this.props.product.id ? this.fetchInternal() : this.fetchExternal();
      }

      fetchInternal() {
        let templates = [];

        this.sectionIds.forEach((sectionId) => {
          const section = document.querySelector(`.shopify-section[id$="${sectionId}"]`);
          if (section) {
            const sectionContent = section.querySelector('.section-content');
            templates.push(sectionContent.outerHTML);
            section.remove();
          }
        });

        const widget = document.querySelector(`.jdgm-widget.jdgm-review-widget[data-id="${this.props.mainProductId}"]`);
        if (widget) {
          templates.push(widget.outerHTML);
          widget.parentElement.remove();
        }

        return templates.join('');
      }

      async fetchExternal() {
        const html = await fetchProductPage(this.props.product.handle);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        let templates = [];

        this.sectionIds.forEach((sectionId) => {
          const section = doc.querySelector(`.shopify-section[id$="${sectionId}"]`);
          if (section) {
            const sectionContent = section.querySelector('.section-content');
            templates.push(sectionContent.outerHTML);
          }
        });

        return templates.join('');
      }

      render(template) {
        this.insertAdjacentHTML('afterbegin', template);
        if (window.lozad) window.lozad('.lazyload').observe();
      }
    }

    customElements.define('block-joint-product-banner', BlockJointProductBanner);
  } catch(e) { console.error(e); }
})();

})();
